new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        activeIndex: 1,
    },
    methods: {
        toggleShowcase(index) {
            this.activeIndex = index;
        }
    },
    mounted() {
        waitForElementToExist('#faixa-cupom').then(element => {
            const faixCupom = document.querySelector('.faixa-cupom');

            if (faixCupom) {
                const formButton = document.querySelector('.faixa-cupom-form button');
                const spanElement = document.getElementById("valorParaCopiar");

                if (spanElement) {
                    let newValue = spanElement.textContent.replace(/^\/\//, '');

                    if (formButton) {
                        formButton.addEventListener("click", (e) => {
                            e.preventDefault();
                            faixCupom.classList.add('active');
                            formButton.textContent = "Copiado!";
                            navigator.clipboard.writeText(newValue).then(() => {
                                
                            }).catch(err => {
                                console.error('Erro ao copiar: ', err);
                                alert("Erro ao copiar o valor.");
                            });
                        });
                    }
                }
            }
        });
    },
});

//sliders
$(document).ready(function () {

    waitForElementToExist('.faixa-comunicado').then(element => { 
        $('.faixa-comunicado').slick({
            arrows: false,
            swipeToSlide: true, 
            touchThreshold: 100,
            dots: false,
            infinite: true,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            speed: 700,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                }
            ]
        });
      });


    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        swipeToSlide: true, 
        touchThreshold: 100,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        infinite: false,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 300,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function (event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.categoria-nav-list').then(element => {
        $('.categoria-nav-list').slick({
            swipeToSlide: true, 
            touchThreshold: 100,
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: false,
            dots: false,
            infinite: false,
            mobileFirst: true,
            autoplay: false, 
            speed: 100,
            responsive: [
                {
                    breakpoint: 991,
                    settings: 'unslick'
                },
            ]
        });
    });

    waitForElementToExist('.banner-instagram').then(element => {
        const bannerInstagram = element.querySelector('.banner-instagram__content');
        if (bannerInstagram) {
            $('.banner-instagram__content').slick({
                arrows: false,
                swipeToSlide: true, 
                touchThreshold: 100,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 3,
                slidesToScroll: 1,
                speed: 1000,
                autoplay: true,
                autoplaySpeed: 3000,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 6,
                        }
                    },
                ]
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        $('#carrousel-product-list').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,

            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        dots: false,
                        arrows: true,
                        prevArrow: $(".count .count-prev"),
                        nextArrow: $(".count .count-next"),
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        dots: false,
                    }
                }
            ]
        });
        $('#carrousel-product-list2').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,

            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        dots: false,
                        prevArrow: $(".count .count-prev2"),
                        nextArrow: $(".count .count-next2"),
                        arrows: true,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        dots: false,
                    }
                }
            ]
        });
        $('#carrousel-product-list3').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        dots: false,
                        prevArrow: $(".count .count-prev3"),
                        nextArrow: $(".count .count-next3"),
                        arrows: true,
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        dots: false,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 1}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list',
                        '#carrousel-product-list2',
                        '#carrousel-product-list3',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list, #carrousel-product-list2, #carrousel-product-list3').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        $('#carrousel-product-list4').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        dots: false,
                        arrows: true,
                        prevArrow: $(".count .count-prev4"),
                        nextArrow: $(".count .count-next4"),
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        dots: false,
                    }
                }
            ]
        });
        $('#carrousel-product-list5').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        dots: false,
                        arrows: true,
                        prevArrow: $(".count .count-prev5"),
                        nextArrow: $(".count .count-next5"),
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        dots: false,
                    }
                }
            ]
        });
        $('#carrousel-product-list6').slick({
            arrows: false,
            swipeToSlide: true,
            touchThreshold: 100,
            dots: true,
            infinite: false,
            mobileFirst: true,
            slidesToShow: 2,
            slidesToScroll: 2,
            speed: 300,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        slidesToScroll: 3,
                        slidesToShow: 3,
                        dots: false,
                        arrows: true,
                        prevArrow: $(".count .count-prev6"),
                        nextArrow: $(".count .count-next6"),
                    }
                },
                {
                    breakpoint: 1275,
                    settings: {
                        slidesToScroll: 4,
                        slidesToShow: 4,
                        dots: false,
                    }
                }
            ]
        });

        if (element) {
            let rotationNames = element.querySelectorAll('.vitrines-select .vitrines-select-name');
            let initVitrine = element.querySelectorAll('.vitrines-products .vitrines-products-item');
            initVitrine = Array.from(initVitrine);

            if (rotationNames.length && initVitrine.length) {
                initVitrine[0].classList.add('active');
                rotationNames[0].classList.add('active');

                function activeTab(index) {
                    initVitrine.forEach((content) => {
                        content.classList.remove('active');
                    });
                    rotationNames.forEach((content) => {
                        content.classList.remove('active');
                    });
                    initVitrine[index].classList.add('active');
                    rotationNames[index].classList.add('active');

                    // Atualizar classe no contêiner .count
                    $('.count').attr('class', function (i, c) {
                        return c.replace(/(^|\s)count-\S+/g, '');
                    }).addClass(`count-${index + 5}`);

                    // Refresh slick carousels and bind afterChange event
                    const carouselIds = [
                        '#carrousel-product-list4',
                        '#carrousel-product-list5',
                        '#carrousel-product-list6',
                    ];
                    carouselIds.forEach(id => {
                        const $carousel = $(id);
                        if ($carousel.hasClass('slick-initialized')) {
                            const totalItems = $carousel.slick('getSlick').slideCount;
                            const $countFirst = $('.count-content .count-first');
                            const $countEnd = $('.count-content .count-end');

                            $countEnd.text(('0' + totalItems));
                            $carousel.slick('refresh').on('afterChange', function (event, slick, currentSlide) {
                                $countFirst.text(('0' + (currentSlide + 1)));
                            });
                        }
                    });
                }

                rotationNames.forEach((itemMenu, index) => {
                    itemMenu.addEventListener('click', (e) => {
                        e.preventDefault();
                        activeTab(index);
                    }, { passive: true });
                });

                // Initial update for the first active tab
                activeTab(0);
            }
        }

        $('#carrousel-product-list4, #carrousel-product-list5, #carrousel-product-list6').on('afterChange', function (event, slick, currentSlide, nextSlide) {
            Blazy({
                selector: '.lazy-img',
                successClass: 'loaded-img',
                success: function (element) {
                    setTimeout(function () {
                        var parent = element.previousSibling;
                        try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/, ''); } catch (e) { }
                    }, 200);
                }
            });
        });
    });

    waitForElementToExist('.product-destaque').then(element => {
        var swiper = new Swiper(".group-images", {
            effect: "coverflow",
            grabCursor: true,
            centeredSlides: true,
            slidesPerView: "auto", // padrão mobile
            coverflowEffect: {
                rotate: 0,
                stretch: 0,
                depth: 100,
                modifier: 2,
                slideShadows: false
            },
            loop: true,
        });
    });	

    waitForElementToExist('.product-ratings').then(element => {
        const productRatings = element.querySelector('.product-ratings-list');
        if(productRatings) {
            $('.product-ratings-list').slick({
                swipeToSlide: true, 
                touchThreshold: 100,
                arrows: false,
                dots: false,
                adaptiveHeight: true,
                autoplay: false,
                autoplaySpeed: 2000,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 100,
                responsive: [
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            dots: false,
                            adaptiveHeight: true,
                            arrows: true,
                            appendArrows: $(".product-ratings .group-arrow"),
                        }
                    },
                ]
            });

            $('.product-ratings-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }
    });

});